import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms'
import { LoadingModule } from '../../../../shared/ui/loading/loading.module'
import { DocumentUploadModule } from '../../../../shared/ui/document-upload/document-upload.module'
import { AttachmentTypeScanDataModule } from '../../components/attachment-type-scan-data/attachment-type-scan-data.module'
import { AddAttachmentDialogComponent } from './add-attachment-dialog.component'

@NgModule({
    declarations: [AddAttachmentDialogComponent],
    exports: [AddAttachmentDialogComponent],
    imports: [
        CommonModule,
        FormsModule,
        LoadingModule,
        DocumentUploadModule,
        AttachmentTypeScanDataModule,
    ],
})
export class AddAttachmentDialogModule {}
